import React from 'react';
import BaseModel from '../../BaseModal';
import { FlexWrapperCenter } from '../../styles/WrapperStyles';
import { BaseButton } from '../../styles/ButtonStyles';
import styled, { css } from 'styled-components';
import { InputText } from '../../styles/TextStyles'


const TextView = styled.p`
  font-family: 'Gilory-Semi';
  font-size: 18px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #484848;
  text-align: center;
  ${props =>
        props.small &&
        css`
      font-size: 16px;
    `}
`;

const RefIdInput = styled(InputText)`
  height: 55px;
  margin-top: 10px;
  margin-bottom: 10px;
`;

const CaptureGooglePaymentModal = (props) => {
    const [productId, setProductId] = React.useState('');
    const [purchaseToken, setPurchaseToken] = React.useState('');

    return (
        <BaseModel
            closeModal={() => {
                props.closeModal();
            }}
        >
            <FlexWrapperCenter
                style={{
                    flexDirection: 'column',
                    alignItems: 'center'
                }}
            >
                <TextView>Product ID</TextView>
                <RefIdInput
                    onChange={e => {
                        setProductId(e.target.value);
                    }}
                ></RefIdInput>
                <TextView>Purchase Token</TextView>
                <RefIdInput
                    onChange={e => {
                        setPurchaseToken(e.target.value);
                    }}
                ></RefIdInput>
                <BaseButton
                    onClick={() => {
                        props.captureGooglePayment(productId, purchaseToken);
                    }}
                >
                    Capture
                </BaseButton>
            </FlexWrapperCenter>
        </BaseModel>
    );
};

export default CaptureGooglePaymentModal;